export function getStorageItem(item) {
  if (typeof window === 'undefined') {
    return ''
  }

  const storageItem = window.sessionStorage.getItem(item)
  return storageItem ? storageItem : ''
}